import Home from '@/views/Home.vue'
import Products from '@/views/Frontend/Products.vue'
import About from '@/views/Frontend/About.vue'
import Quality from '@/views/Frontend/Quality.vue'
import Manufacture from '@/views/Frontend/Manufacture.vue'

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/products",
    name: "products",
    component: Products,
  },
  {
    path: "/about",
    name: "about",
    component: About,
  },
  {
    path: "/manufacture",
    name: "manufacture",
    component: Manufacture,
  },
];


export default routes